import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import Input from "components/bootstrap/Input";
import { Panel } from "components/bootstrap";
import WatchlistSelector from "./WatchlistSelector";
const StyledInlineCode = styled("code")`
  margin: 0 0.25em;
  white-space: nowrap;
`;
const WatchlistParameterForm = ({
  idx,
  onChange,
  validationState,
  parameter,
  onValidate
}) => {
  var _a, _b;
  const { t } = useTranslation("enterprise_common");
  const { watchlistId, name } = parameter;
  const parameterSyntax = `$${name}$`;
  useEffect(() => {
    const state = watchlistId ? ["success"] : ["error", t("parameters.watchlist_form.select_watchlist")];
    onValidate(idx, { watchlistId: state });
    return () => onValidate(idx, { watchlistId: ["success"] });
  }, [watchlistId, idx, onValidate, t]);
  const _onChange = (selectedId) => onChange("watchlistId", selectedId);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `watchlist-${idx}`,
      name: "watchlistId",
      label: t("parameters.watchlist"),
      bsStyle: (_a = validationState == null ? void 0 : validationState.watchlistId) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState.watchlistId) == null ? void 0 : _b[1]
    },
    /* @__PURE__ */ React.createElement(WatchlistSelector, { id: `watchlist-selector-${idx}`, value: watchlistId, onChange: _onChange })
  ), /* @__PURE__ */ React.createElement(Panel, { id: "watchlist-parameter-help" }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, t("parameters.watchlist_form.help_title"))), /* @__PURE__ */ React.createElement(Panel.Collapse, null, /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("h5", null, t("parameters.watchlist_form.general_usage")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "parameters.watchlist_form.general_usage_text",
      values: { syntax: parameterSyntax },
      components: { inlineCode: /* @__PURE__ */ React.createElement(StyledInlineCode, null) }
    }
  )), /* @__PURE__ */ React.createElement("h5", null, t("parameters.watchlist_form.limitations")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "parameters.watchlist_form.limitations_text",
      components: { inlineCode: /* @__PURE__ */ React.createElement(StyledInlineCode, null) }
    }
  ))))));
};
export default WatchlistParameterForm;
